<div fxFlex fxLayout="column">
  <div class="sticky">
    <iot-platform-ui-toolbar-v2
      (dispatchToolbarEvent)="onToolbarEvent($event)"
      [buttonList]="toolbarButtonList()"
      [isDataLoaded]="loaded()"
      [name]="'ASSETS.NAME_TOOLBAR' | translate"
      [total]="totalItems()"
      [size]="ToolbarSize.SMALL"
    />

    <iot-platform-ui-filter-engine-v2
      (applyFilters)="onApplyFilters($event)"
      [currentFavoriteView]="currentFavoriteView$ | async"
      [currentFilters]="filtersToDisplay()"
      [expanded]="filterEngineOpened()"
      [masterView]="'assets'"
    />
  </div>
  <div class="p-4" fxFlex fxLayout="row">
    <i4b-table-engine-master-view-engine
      (dispatchMasterViewEngineEvent)="onMasterViewEngineEvent($event)"
      (pageChange)="onPageChange($event)"
      [data]="platformResponse()"
      [masterViewType]="{ name: 'assets', isPath: false }"
      [pageSizeOptions]="pageSizeOptions()"
      [sticky]="true"
      [useExternalData]="true"
      fxFlex
    />
  </div>
</div>
